import React from 'react';
import { CheckCircleOutlineOutlined } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { publicPath } from '@/operator/utils/env/urlStrings';
import { StyledCardConnectionContainer } from './Styles';

interface CardConnectionProps {
    readonly imgSrc: string;
    readonly label: string;
    readonly onClick?: () => void;

    readonly connected?: boolean;

    readonly imgWidth?: string;
    readonly imgHeight?: string;
}
function CardConnection({
    imgSrc,
    label,
    onClick,
    connected,
    imgWidth,
    imgHeight,
}: CardConnectionProps) {
    const theme = useTheme();
    const imgSource = imgSrc;

    const labelColor = connected
        ? theme.palette.success.main
        : theme.palette.primary.main;

    return (
        <StyledCardConnectionContainer onClick={onClick}>
            {connected && (
                <CheckCircleOutlineOutlined
                    color="success"
                    sx={{
                        alignSelf: 'flex-end',
                        marginRight: '8px',
                        marginTop: '-20px',
                    }}
                />
            )}
            <img
                src={`${imgSource}`}
                alt="placeholder"
                width={imgWidth ? imgWidth : '132.5px'}
                height={imgHeight ? imgHeight : '100px'}
            />
            <Typography
                variant="body1"
                fontWeight={700}
                sx={{
                    color: labelColor,
                }}
            >
                {label}
            </Typography>
        </StyledCardConnectionContainer>
    );
}

export default CardConnection;
